import { Dropdown } from "antd";

import { CurrentUserAvatar } from "@/modules/current-user-avatar";

import { useUserDropdownMenu } from "./user-dropdown-menu.hook";

export const UserDropdownMenu = () => {
  const menu = useUserDropdownMenu();

  return (
    <Dropdown
      menu={menu}
      trigger={["click"]}
      placement="bottomRight"
      arrow={{ pointAtCenter: true }}
    >
      <div>
        <CurrentUserAvatar clickable />
      </div>
    </Dropdown>
  );
};
